import { Status } from '../../../shared/enums/status.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Translation } from '../../../shared/models/translation.model';
import { HighlightType } from '../products/enum/highlight-type.enum';
import { Product } from '../products/models/product.model';

export class Category {
  id: number;
  name: string;
  description: string;
  amount: number;
  order: number;
  establishmentId: number;
  status: Status;
  translations: Translation[];
  highlightType: HighlightType;
  products?: Product[];

  // Aux view
  nameTranslations: Translation;
  descriptionTranslations: Translation;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, Status);
    } else if (this.status == null || this.status['code'] == null) {
      this.status = Status.ACTIVE;
    }

    if (this.products && this.products.length > 0) {
      const products = [];
      for (let p of this.products) {
        products.push(new Product(p));
      }
      this.products = products;
    }
  }

  toJson(): any {
    const data: any = {
      id: this.id || null,
      name: this.name,
      description: this.description,
      amount: this.amount,
      order: this.order,
      establishmentId: this.establishmentId,
      status: this.status['code'],
      highlightType: this.highlightType || null,
    };
    return data;
  }

  toReorderJson(): any {
    const data: any = {
      id: this.id || null,
      order: this.order,
    };
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/category/models/category.model.ts